import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'

interface BackupCodeInputProps {
  onSubmit: (code: string) => void
  onBackToTOTP?: () => void
  isLoading?: boolean
  error?: string
}

export function BackupCodeInput({
  onSubmit,
  onBackToTOTP,
  isLoading,
  error,
}: BackupCodeInputProps) {
  const { t } = useTranslation()
  const [code, setCode] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (code.trim()) {
      onSubmit(code.trim())
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="backup-code">{t('auth.backupCode', 'Enter backup code')}</Label>
        <Input
          id="backup-code"
          type="text"
          value={code}
          onChange={e => setCode(e.target.value)}
          placeholder="XXXX-XXXX-XXXX-XXXX"
          className="text-center font-mono"
          disabled={isLoading}
          autoFocus
        />
        {error && <p className="text-sm text-destructive text-center">{error}</p>}
        <p className="text-xs text-muted-foreground text-center">
          {t('auth.backupCodeDescription', 'Use one of your backup codes saved during 2FA setup')}
        </p>
      </div>

      <div className="space-y-2">
        <Button type="submit" className="w-full" disabled={isLoading || !code.trim()}>
          {isLoading ? t('algemeen.laden', 'Loading...') : t('auth.verify', 'Verify')}
        </Button>

        {onBackToTOTP && (
          <Button
            type="button"
            variant="ghost"
            onClick={onBackToTOTP}
            className="w-full"
            disabled={isLoading}
          >
            {t('auth.backToTOTP', 'Back to authenticator code')}
          </Button>
        )}
      </div>
    </form>
  )
}
